import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';

/**
 * A sponsor's physical location, built from `/admin/sponsors/:id/locations` JSON
 * (hub `data-models/sponsor-location.ts`). The hub's audit ids (`createdBy`, `archivedBy`, ...) are not mapped.
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class SponsorLocation extends Base {
  // Writable via POST / PUT /admin/sponsors/:id/locations
  name?: string | null;
  street1?: string | null;
  street2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  phone?: string | null;
  email?: string | null;

  // Read-only
  sponsorId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.street1 = nullableString(source['street1']);
    this.street2 = nullableString(source['street2']);
    this.city = nullableString(source['city']);
    this.state = nullableString(source['state']);
    this.zipCode = nullableString(source['zipCode']);
    this.latitude = nullableNumber(source['latitude']);
    this.longitude = nullableNumber(source['longitude']);
    this.phone = nullableString(source['phone']);
    this.email = nullableString(source['email']);
    this.sponsorId = nullableString(source['sponsorId']);
  }
}
